import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadLang } from '@nayto/i18n';
import { AppShell } from './AppShell';
import { ServicesProvider } from './services-context';
import { DEFAULT_LANG, detectInitialLang } from './lang-boot';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found in index.html');

// ServicesProvider wraps the shell so every screen reads the same live
// service config. It renders children immediately with the static
// default — there is no loading state to wait through, and a deployment
// whose /api/services 404s (production, today) never notices it exists.
function render() {
  ReactDOM.createRoot(rootEl!).render(
    <React.StrictMode>
      <ServicesProvider>
        <AppShell />
      </ServicesProvider>
    </React.StrictMode>,
  );
}

// ─── Boot order (F-08) ───────────────────────────────────────────────
//
// The dictionary is a lazily-loaded chunk now, and `t()` is synchronous.
// Those two facts only coexist if the dictionary is in memory before the
// first render — otherwise the first frame renders `chQuotaPerDay` where
// a sentence belongs, and no amount of care inside components fixes it.
//
// So the render is awaited on exactly one promise. It is a ~25 kB fetch
// from the same origin, already in flight while the browser parses the
// rest of the entry chunk.
//
// If it fails, English is tried once — a reader who is offline mid-boot
// should get a working app in the wrong language rather than an empty
// page. If THAT fails too there is no dictionary to render with, and the
// app renders anyway: `tFn` degrades to the key text, which is ugly and
// legible, and the alternative is a white screen.
const lang = detectInitialLang();
loadLang(lang)
  .catch(() => (lang === DEFAULT_LANG ? Promise.resolve() : loadLang(DEFAULT_LANG)))
  .catch(() => undefined)
  .finally(render);
